var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(
      _vm.headerRoutes.indexOf(_vm.$route.name) < 0 &&
      _vm.$utile._isMobile() &&
      _vm.currentRoute != '/darenMonitor' &&
      _vm.currentRoute != '/darenDetails' && 
      _vm.currentRoute != '/earlyWarn' &&
      _vm.currentRoute != '/brandPublicOpinion' &&
      _vm.currentRoute != '/pointsDetails' &&
      _vm.currentRoute != '/deductionExplanation' &&
      _vm.currentRoute != '/personalData'
    )?_c('mobileHeaders'):_vm._e(),(
      (_vm.headerRoutes.indexOf(_vm.$route.name) < 0 &&
        _vm.$utile._isMobile() === null) ||
      _vm.currentRoute == '/darenMonitor' ||
      _vm.currentRoute == '/darenDetails' ||
      _vm.currentRoute == '/earlyWarn' ||
      _vm.currentRoute == '/brandPublicOpinion' ||
      _vm.currentRoute == '/pointsDetails' ||
      _vm.currentRoute == '/deductionExplanation' ||
      _vm.currentRoute == '/personalData'
    )?_c('headers'):_vm._e(),_c('router-view'),(
      (_vm.headerRoutes.indexOf(_vm.$route.name) < 0 &&
        _vm.$utile._isMobile() === null) ||
      _vm.currentRoute == '/darenMonitor' ||
      _vm.currentRoute == '/darenDetails' ||
      _vm.currentRoute == '/earlyWarn' ||
      _vm.currentRoute == '/brandPublicOpinion' ||
      _vm.currentRoute == '/pointsDetails' ||
      _vm.currentRoute == '/deductionExplanation' ||
      _vm.currentRoute == '/personalData'
    )?_c('bottom'):_vm._e(),(
      _vm.headerRoutes.indexOf(_vm.$route.name) < 0 &&
      _vm.$utile._isMobile() &&
      _vm.currentRoute != '/darenMonitor' &&
      _vm.currentRoute != '/darenDetails' &&
      _vm.currentRoute != '/earlyWarn' &&
      _vm.currentRoute != '/brandPublicOpinion' &&
      _vm.currentRoute != '/pointsDetails' &&
      _vm.currentRoute != '/deductionExplanation' &&
      _vm.currentRoute != '/personalData'
    )?_c('mobileBottom'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }